import { render, staticRenderFns } from "./view-user.vue?vue&type=template&id=3bdd50ad&"
import script from "./view-user.vue?vue&type=script&lang=js&"
export * from "./view-user.vue?vue&type=script&lang=js&"
import style0 from "./view-user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports